import React from 'react'

// Horizontal tab strip used by a núcleo to switch between its own data and the data of each
// associated company. The first tab is always the logged company.
//
// tabs: [{ id, label, icon, title?, inactive? }]

const CompanyTabs = ({ tabs, activeId, onChange }) => (
  <div
    role="tablist"
    aria-label="Empresas do núcleo"
    className="flex items-stretch gap-1 mb-4 border-b border-gray-200 dark:border-gray-700 overflow-x-auto"
  >
    {tabs.map((tab) => {
      const isActive = tab.id === activeId
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          title={tab.title || tab.label}
          onClick={() => onChange(tab.id)}
          className={`flex items-center gap-2 px-4 py-2.5 -mb-px text-sm whitespace-nowrap border-b-2 transition flex-shrink-0 max-w-[260px] ${
            isActive
              ? 'border-blue-500 text-blue-600 dark:text-blue-400 dark:border-blue-400 font-semibold'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'
          } ${tab.inactive ? 'opacity-60' : ''}`}
        >
          <span className="material-icons flex-shrink-0" style={{ fontSize: '16px' }}>{tab.icon}</span>
          <span className="truncate">{tab.label}</span>
          {tab.inactive && (
            <span className="flex-shrink-0 text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500">inativa</span>
          )}
        </button>
      )
    })}
  </div>
)

export default CompanyTabs
